var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',{staticClass:"bg-dark"},[_c('div',{staticClass:"icones"},[_c('b-link',{attrs:{"to":'/LegalMentions',"target":"_blank"}},[_vm._v("Legal notices")]),_vm._v(" | "),_c('b-link',{attrs:{"to":'/PrivacyNotice',"target":"_blank"}},[_vm._v("Privacy Notice")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }